import styled from 'styled-components';

import colors from '@/design/colors';
import { Text } from '@/design/typography';

export const EditSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const EditedLabel = styled.span.attrs({
  children: 'editado',
})`
  ${Text(14)};
  color: ${colors.gray200};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
